import React from "react";
import Lottie from "react-lottie-player";
import StateAnimation from "./defaultStateAnimation.json";

export default function LoadingState() {
  // return (
  //   <div className="d-flex flex-column w-100 h-100 align-items-center">
  //     <Lottie
  //       loop
  //       animationData={StateAnimation}
  //       play
  //       style={{ width: 300, height: 300 }}
  //     />
  //     <p className="m-0 fw-semiobold opacity-75">Processing... Please wait.</p>
  //   </div>
  // );
  const [dots, setDots] = React.useState("");

  React.useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? "" : prev + "."));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="d-flex flex-column w-100 align-items-center justify-content-center"
      style={{
        minHeight: "400px",
        padding: "40px 20px",
      }}
    >
      {/* Animation Container */}
      <div
        style={{
          position: "relative",
          marginBottom: "32px",
        }}
      >
        {/* Glow Effect */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "320px",
            height: "320px",
            background:
              "radial-gradient(circle, rgba(131, 193, 74, 0.15) 0%, transparent 70%)",
            borderRadius: "50%",
            animation: "pulse-glow 2s ease-in-out infinite",
          }}
        />

        <Lottie
          loop
          animationData={StateAnimation}
          play
          style={{
            width: 280,
            height: 280,
            position: "relative",
            zIndex: 1,
          }}
        />
      </div>

      {/* Loading Text */}
      <h4
        style={{
          fontSize: "20px",
          fontWeight: "700",
          color: "#1e293b",
          marginBottom: "8px",
          textAlign: "center",
        }}
      >
        Processing{dots}
      </h4>

      <p
        style={{
          fontSize: "14px",
          fontWeight: "500",
          color: "#64748b",
          marginBottom: "24px",
          textAlign: "center",
        }}
      >
        Please wait while we load your data
      </p>

      {/* Progress Bar */}
      <div
        style={{
          width: "240px",
          height: "4px",
          background: "#e2e8f0",
          borderRadius: "4px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            background: "linear-gradient(90deg, #83c14a, #6fad3e)",
            borderRadius: "4px",
            animation: "loading-bar 1.5s ease-in-out infinite",
          }}
        />
      </div>

      {/* CSS Animations */}
      <style>{`
        @keyframes pulse-glow {
          0%, 100% {
            opacity: 0.4;
            transform: translate(-50%, -50%) scale(0.95);
          }
          50% {
            opacity: 0.6;
            transform: translate(-50%, -50%) scale(1.05);
          }
        }

        @keyframes loading-bar {
          0% {
            width: 0%;
            margin-left: 0%;
          }
          50% {
            width: 70%;
            margin-left: 15%;
          }
          100% {
            width: 0%;
            margin-left: 100%;
          }
        }
      `}</style>
    </div>
  );
}
